import { Component, Input, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

import { CallbackService } from './callback.service';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-callback',
  templateUrl: './callback.component.html',
  styleUrls: ['./callback.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class CallbackComponent implements OnInit {
  public callbackLoading: boolean;

  @Input() ticketNumber;

  constructor(private callbackService: CallbackService) {}

  ngOnInit() {}

  public sendCallback() {
    this.callbackLoading = true;
    this.callbackService.makeCallback({ ticket_number: this.ticketNumber }).subscribe(
      (response) => {
        this.callbackLoading = false;
      },
      (error) => {
        alert('Ошибка сервера обратного дозвона!');
        this.callbackLoading = false;
      }
    );
  }
}
